export const LABELS = {
  ADD_HOTEL: 'Add Hotel',
  ADD_FLIGHT: 'Add Flight',
  DIFFERENT_DROPOFF: 'Return car to a different location',
  PACKAGE_DEALS: 'Package Deals',
  CAR_CATEGORY: 'Car type',
  PASSENGERS: 'Passengers',
  PASSENGERS_WITH_HOTEL: 'Passengers with Hotel',
  DEFAULT_LOCATION: 'City, Airport or Address',
  PICKUP_TIME: 'Pick-up Time',
  PICKUP_DATE: 'Pick-up',
  DROPOFF_DATE: 'Drop-off',
  DROPOFF_TIME: 'Drop-off Time',
  SEARCH_BUTTON: 'Find Your Car',
} as const

export const DEFAULT_VALUES = {
  ADD_HOTEL: false,
  ADD_FLIGHT: false,
  DIFFERENT_DROPOFF: false,
  PICKUP_TIME: '12:00',
  DROPOFF_TIME: '12:00',
} as const
